"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseHttpRequest = void 0;
class BaseHttpRequest {
    constructor(config) {
        this.config = config;
    }
}
exports.BaseHttpRequest = BaseHttpRequest;
